import React from 'react';
import { useTranslation } from 'react-i18next';
import ExportCSVData from './ExportCSVData';

function ExportCSVButton({ data = [], text }) {
  const [t] = useTranslation();

  if (data.length === 0) return null;
  return <ExportCSVData data={data} />;
}

export default ExportCSVButton;
